import { render, staticRenderFns } from "./event-editor.vue?vue&type=template&id=1d8d417d&scoped=true&"
import script from "./event-editor.vue?vue&type=script&lang=js&"
export * from "./event-editor.vue?vue&type=script&lang=js&"
import style0 from "./event-editor.vue?vue&type=style&index=0&id=1d8d417d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8d417d",
  null
  
)

export default component.exports